/* eslint-disable default-param-last */
import { combineReducers } from 'redux';
import * as Types from './plan.constants';

function makeRequestReducer(actionType, defaultData = [], state = {}) {
  const initialState = {
    data: defaultData,
    error: false,
    loading: false,
    ...state,
  };
  return (state = initialState, action) => {
    switch (action?.type) {
      case `${actionType}_REQUEST`:
        return {
          ...state,
          loading: true,
          error: false,
        };
      case `${actionType}_SUCCESS`:
        return {
          ...state,
          loading: false,
          error: false,
          data: action?.payload?.data,
        };
      case `${actionType}_FAILED`:
        return {
          ...state,
          loading: false,
          error: true,
          data: defaultData,
        };
      case `${actionType}_RESET`:
        return state;
      default:
        return state;
    }
  };
}

export default combineReducers({
  addPlan: makeRequestReducer(Types.ADD_PLAN),
  updatePlan: makeRequestReducer(Types.UPDATE_PLAN),
  addPackage: makeRequestReducer(Types.ADD_PACKAGES),
  updatePackage: makeRequestReducer(Types.UPDATE_PACKAGES),
  getPlan: makeRequestReducer(Types.GET_PLAN, {}),
  plansList: makeRequestReducer(Types.GET_PLANS_LIST),
  package: makeRequestReducer(Types.GET_PACKAGE, {}),
  packagesList: makeRequestReducer(Types.GET_PACKAGES_LIST)
});
